"use client";
import React, { useEffect, useState } from "react";
import PageTitle from "@/components/common-components/page-title/PageTitle";
import { Container } from "react-bootstrap";
import ServiceCard from "@/components/common-components/service-card/ServiceCard";
import FaqSection from "@/components/common-components/faqs/FaqSection";
import CustomPagination from "@/components/common-components/CustomPagination";
import { useDispatch, useSelector } from "react-redux";
import {
  allSubCategories,
} from "@/redux/treatmentSlice";
import axios from "axios";

import { generateCacheKey, withManualCache } from "@/utlility/cache-service";
import { fetchNavigationData } from "@/utlility/api-helpers";

const AllTreatments = () => {
  const API_URL = process.env.NEXT_PUBLIC_API_URL;
  const ORG_KEY = process.env.NEXT_PUBLIC_ORGANIZATION_KEY;
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [marketArea, setMarketArea] = useState("");
  const limit = 12;

  const reduxFeaturesData = useSelector((state) => state?.organization?.featuresData);
  const { data, total_records } = useSelector(
    (state) => state?.treatment?.treatmentList
  );

  useEffect(() => {
    async function getNavigationData() {
      try {
        const result = reduxFeaturesData || await fetchNavigationData();

        if (result?.market_area) {
          let temp = result.market_area.find(
            (item) => item?.is_default === true
          );
          setMarketArea(temp);
        }
      } catch (error) {
        // console.error("Error fetching navigation data:", error);
      }
    }
    getNavigationData();
  }, [reduxFeaturesData]);

  useEffect(() => {
    const payload = {
      organization_key: ORG_KEY,
      page: page + 1,
      limit,
    };
    dispatch(allSubCategories({ payload }));
  }, [dispatch, page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <PageTitle
        image="/images/contact-bg.webp"
        name="All Treatments"
        link={"/all-treatments"}
      />
      <section className="all-treatments">
        <Container>
          <div className="d-flex flex-column cover">
            <div className="grid gap-4" style={{ marginBottom: "60px" }}>
              {data?.map((item, i) => (
                <ServiceCard
                  image={item?.category_image}
                  title={item.category_name}
                  parentCategory={item?.parent_category?.category_name}
                  parentSlug={item?.parent_category?.category_slug}
                  childSlug={item?.category_slug}
                  marketArea={marketArea}
                  className="g-col-12 g-col-sm-6 g-col-lg-4" key={i}
                  imageStyle={{
                    maxHeight: "172px"
                  }}
                />
              ))}
            </div>
            {total_records > 12 && (
              <CustomPagination
                currentPage={page}
                totalRecords={total_records}
                limit={limit}
                onPageChange={handlePageChange}
                className="m-0 gap-2 justify-content-center"
              />
            )}
          </div>
        </Container>
      </section>
      <FaqSection />
    </>
  );
};

export default AllTreatments;
